class SessionService {
  constructor ($cookies, $window, $q, $http, ngAuthSettings) {
    this.ngAuthSettings = ngAuthSettings;
    this.$cookies = $cookies;
    this.$q = $q;
    this.$http = $http;
    this.branches = null;
    this.models = [
      'contactEmail',
      'contactFirstName',
      'contactLastName',
      'contactName',
      'contactPosition',
      'firstname',
      'fullname',
      'isB2B',
      'isContactCenter',
      'isLogged',
      'applyLogisticsService',
      'isMaster',
      'isOwner',
      'isNatural',
      'isSupervisor',
      'paymentMethod',
      'isProvider',
      'isSeller',
      'operatingCenter',
      'operatingCenterId',
      'sellerExt',
      'sellerId',
      'thirdAttendantTypeId',
      'thirdAttendantTypeName',
      'thirdDocumentDV',
      'thirdDocumentNumber',
      'thirdDocumentTypeId',
      'thirdDocumentTypeName',
      'thirdId',
      'thirdName',
      'userId',
      'username',
      'favoriteItems'
    ];
    this.store = $window.localStorage;

    this.cart = "";
  }

  /**
   * @method get              Get akey value
   * @param  {string} key     Key to get
   */
  get(key) {
   
    if (key === 'globals') {
      this.getGlobals().then(response => {
        return response;
      });
    } else {
      let result = this.store.getItem(key);
      try {
        result = JSON.parse(result);
      } catch(e){}
      return result;
    }
  }

  /**
   * @method put              Set the key-value pair in the session
   * @param  {string} key     Key to set
   * @param  {object} value   Key value to set
   */
  put(key, value) {
    
    if (key === 'globals') {
      let currentUser = {};
      this.models.forEach(val => {
        if (value.currentUser) {
          currentUser[val] = value.currentUser[val];
        }
      });

      try { 
        this.store.setItem('currentUser', JSON.stringify(currentUser));
      }
      catch (e) {
        this.store.setItem('currentUser', currentUser);
      }
      try {
        this.store.setItem('currentClient', JSON.stringify(value.currentClient));
      }
      catch (e) {
        this.store.setItem('currentClient', value.currentClient);
      }
    } else {
      try {
        this.store.setItem(key, JSON.stringify(value));
      }
      catch (e) {
        this.store.setItem(key, value);
      }
    }
  }

  /**
   * @method remove         Remove key from session
   * @param {string} key    Key to remove from session
   */
  remove(key) {
    if (key === 'globals') {
      this.store.removeItem('currentUser');
      this.store.removeItem('currentClient');
      
      // this.$cookies.remove('operatingCenters');
    } else {
      this.store.removeItem(key);
    }
  }

  getGlobals(){
   
    return this.$q((resolve, reject) => {
      let currentUser = this.store.getItem('currentUser'),
        currentClient = this.store.getItem('currentClient');
      try {
        currentUser = JSON.parse(currentUser);
      } catch(e){}
      try {
        currentClient = JSON.parse(currentClient);
      } catch(e){}
      if(currentUser && currentUser.userId){
        if(this.branches){

          currentUser['operatingCenters'] = this.branches;
          resolve({
            'currentUser': currentUser,
            'currentClient': currentClient
          });
        } else {

          this.$http({
            method: 'GET',//actionGetOperatingCentersByUserId
            url: this.ngAuthSettings.apiServiceBaseUri  + '/login/get-operating-centers-by-user-id?userId=' + currentUser.userId+"&origen=b2b",
            cache : false,
            headers: { 'Content-Type': 'application/json' }
          }).then(response => {
            currentUser['operatingCenters'] = response.data.data;
            this.branches = response.data.data;
            resolve({
              'currentUser': currentUser,
              'currentClient': currentClient
            });
          }).catch(reason => {
            resolve({
              'currentUser': currentUser,
              'currentClient': currentClient
            });
          });
        }

      } else {
        resolve({
          'currentUser': currentUser,
          'currentClient': currentClient
        });
      }

    });
  }

  getTemplate(){
    // this.getDataComponent().then(response => {
    //   console.log("service ola",response);
    //    return response;
    // });
    return 'template1';
  }
  getDataComponent(){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',//actionGetOperatingCentersByUserId
        url: this.ngAuthSettings.config.env.apiEndPoint  + '/adminComponentes/components',
        cache : false,
        headers: { 'Content-Type': 'application/json' }
      }).then(response => {
        resolve( response.data);
      });
});
  }

  loadCartInfo(data,key){
    if(key == 'get'){
      return this.cart;
    }
    else if(key == 'put'){
      this.cart = data;
    }
  }

  validateFactorItems(quantity,product){

    if(product.cantidad_minima > quantity){
        return {error:true,message:"<p>Lo sentimos, para el producto <b>"+ product.name+"</b> la cantidad mínima permitida de compra es <b>"+product.cantidad_minima+"</b></p>"};
    }
    if(angular.isDefined(product.factor) && product.factor > 0){
    let quantityAdd = quantity - product.cantidad_minima;
    let mod = quantityAdd %  product.factor;

    if(mod > 0){
      return {error:true,message:"<p>Lo sentimos, el producto <b>"+product.name+"</b> debe ser agregado en factor de <b>"+product.factor+"</b> unidades, a partir de la cantidad mínima: <b>"+product.cantidad_minima+"</b></p>"};
    }else{
      return {error:false};
    }
  }
  return {error:false};
  }
}

SessionService.$inject = ['$cookies', '$window', '$q', '$http', 'ngAuthSettings'];

export default SessionService;




/** WEBPACK FOOTER **
 ** ./www/components/shared/components/session/session.service.js
 **/